import { getToken } from "./getToken";

export const isLoggedin = () => {
	if (getToken()) {
		return true;
	}
	return false;
};
